import { render, staticRenderFns } from "./FooterPellets.vue?vue&type=template&id=2b477b8e&scoped=true"
import script from "./FooterPellets.vue?vue&type=script&lang=ts"
export * from "./FooterPellets.vue?vue&type=script&lang=ts"
import style0 from "./FooterPellets.vue?vue&type=style&index=0&id=2b477b8e&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b477b8e",
  null
  
)

export default component.exports